import { useMemo } from 'react'
import { selectInProgressCookingProgresses, useAppSelector, useT, type Recipe } from '@reciperoll/core'
import { RecipeGridItem } from './RecipeGridItem'

interface RecipeGridProps {
  recipes: Recipe[]
  emptyMessage?: string
}

export function RecipeGrid({ recipes, emptyMessage }: RecipeGridProps) {
  const t = useT()
  const inProgress = useAppSelector(selectInProgressCookingProgresses)
  const cookingIds = useMemo(() => new Set(inProgress.map((cp) => cp.recipeId)), [inProgress])

  if (recipes.length === 0) {
    return <p className="text-ink-faint text-sm">{emptyMessage ?? t('library.emptyDefault')}</p>
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {recipes.map((recipe) => (
        <RecipeGridItem key={recipe.id} recipe={recipe} isCooking={cookingIds.has(recipe.id)} />
      ))}
    </div>
  )
}
